"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoObjectForMapFragmentDoc = exports.GeoObjectFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
const Region_generated_1 = require("./Region.generated");
exports.GeoObjectFullFragmentDoc = client_1.gql `
    fragment GeoObjectFull on GeoObject {
  Id
  Status
  Lat
  Long
  Address
  City
  Containers
  SpecialContainers
  StartAt
  EndAt
  AllTime
  Description
  WorkingHours
  Org
  Email
  Phone
  URL
  Type
  LoginId
  Distance
  FavoriteId
  RecycledType {
    Type
  }
  Region {
    ...RegionFull
  }
}
    ${Region_generated_1.RegionFullFragmentDoc}`;
exports.GeoObjectForMapFragmentDoc = client_1.gql `
    fragment GeoObjectForMap on GeoObject {
  Id
  Status
  Lat
  Long
  Type
}
    `;
//# sourceMappingURL=GeoObject.generated.js.map